<template>
    <div class="screen">
        <p>Please wait while we use the code to retrieve an access token...</p>
        <b-loading :is-full-page="true" :active.sync="loadingOverlay" :can-cancel="true"></b-loading>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "screenauthenticated",
    components: {},
    data() {
      return {};
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay'])
    },
    methods: {
      ...mapActions('auth', ['fetchAccessToken', 'initialize'])
    },
    mounted() {
      const that = this;
      const payload = {
        ...that.$route.query,
        callback: () => {
          this.initialize({
            callback: () => {
              that.$store.commit('ui/HIDE_OVERLAY');
              that.$router.push('/');
            }
          });
        }
      };
      this.fetchAccessToken(payload);
    }
  }
</script>

<style scoped>
    .screen {
        margin-top: 1rem;
    }
</style>